export type BrandingFormState = {
  primary_color: string;
  secondary_color: string;
  accent_color: string;
  background_color: string;
  text_color: string;
  dark_primary_color: string;
  dark_secondary_color: string;
  dark_accent_color: string;
  dark_background_color: string;
  dark_text_color: string;
  chart_primary_color: string;
  chart_secondary_color: string;
  chart_accent_color: string;
  chart_palette: string;
  dark_chart_primary_color: string;
  dark_chart_secondary_color: string;
  dark_chart_accent_color: string;
  dark_chart_palette: string;
  logo_url: string;
  logo_dark_url: string;
  dark_logo_url: string;
};

export type ClientManagementState = {
  departmentName: string;
  departmentActive: boolean;
  jobRoleName: string;
  jobRoleActive: boolean;
  assignUserId: string;
};

export type CreateClientFormState = {
  name: string;
  is_active: boolean;
  learning_locker_enabled: boolean;
  occupational_health_enabled: boolean;
  wearables_enabled: boolean;
  akea_life_enabled: boolean;
};

export const emptyFormState: BrandingFormState = {
  primary_color: "",
  secondary_color: "",
  accent_color: "",
  background_color: "",
  text_color: "",
  dark_primary_color: "",
  dark_secondary_color: "",
  dark_accent_color: "",
  dark_background_color: "",
  dark_text_color: "",
  chart_primary_color: "",
  chart_secondary_color: "",
  chart_accent_color: "",
  chart_palette: "",
  dark_chart_primary_color: "",
  dark_chart_secondary_color: "",
  dark_chart_accent_color: "",
  dark_chart_palette: "",
  logo_url: "",
  logo_dark_url: "",
  dark_logo_url: "",
};

export const emptyManagementState: ClientManagementState = {
  departmentName: "",
  departmentActive: true,
  jobRoleName: "",
  jobRoleActive: true,
  assignUserId: "",
};

export const emptyCreateClientForm: CreateClientFormState = {
  name: "",
  is_active: true,
  learning_locker_enabled: false,
  occupational_health_enabled: false,
  wearables_enabled: false,
  akea_life_enabled: false,
};
